import reporter from './reporter'
import locale from './locale'

export default {
  serverUrl: 'https://healthcarebyzwizai.herokuapp.com/',
  facebookUrl: 'https://graph.facebook.com/',
  appid: '1643313969058967', 

  theme: {
    logo: '/static/img/logo_white.png',
    small_logo: '/static/img/logo-small.png',
    short_small_logo: '/static/img/logo-small-mobile.png',
    hide_zwiz: false,
    email_contact: 'sales@zwiz.ai',
    header_color: 'white',
    header_background_color: '#504F4F',
    brand_color: '#ff5348', //#ed1839
    secondary_color: '#ff687f', //#ff687f
  },
  
  fb_scope: 'email,public_profile,manage_pages,pages_messaging,pages_messaging_subscriptions,read_page_mailboxes',

  reporter : reporter	,
  locale: locale.locale
}


// WEBPACK FOOTER //
// ./src/config/index.js